export default {
    email: 'Email',
    SideBySide: 'Simple side by side form',
    Stacked: 'Simple stacked form',
    username: 'Username',
    usernameHelpText: 'Letters, digits and ./+/-/_ only.',
};
